import { render, staticRenderFns } from "./DeliveryNotesProfileCard.vue?vue&type=template&id=0d15de2d&scoped=true&"
import script from "./DeliveryNotesProfileCard.vue?vue&type=script&lang=js&"
export * from "./DeliveryNotesProfileCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d15de2d",
  null
  
)

export default component.exports